import PropTypes from 'prop-types';

const NoValidInvalidPartsMessage = ({ message }) => {
  return (
    message && (
      <p className="u-fs--16 text-sans-serif u-color--DarkGray my-3">
        {message}
      </p>
    )
  );
};

NoValidInvalidPartsMessage.propTypes = {
  message: PropTypes.string
};

export default NoValidInvalidPartsMessage;
